import React, { useState } from 'react';
import PropTypes from 'prop-types';

const PasswordManagement = ({ employeeId, onChangePassword, loading }) => {
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({
      ...passwordData,
      [name]: value
    });
  };  

  const handleSubmit = (e) => {
    e.preventDefault();
    onChangePassword({
      emp_id: employeeId,
      ...passwordData
    });
  };

  const togglePasswordForm = () => {
    setShowPasswordForm(!showPasswordForm);
    if (!showPasswordForm) {
      // Reset password fields when opening form
      setPasswordData({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    }
  };

  return (
    <div className="profile-section password-section">
      <div className="section-header">
        <h3>Password Management</h3>
        <button
          className="change-password-btn"
          onClick={togglePasswordForm}
        >
          {showPasswordForm ? 'Cancel' : 'Change Password'}
        </button>
      </div>
      
      {showPasswordForm && (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="oldPassword">Old Password:</label>
            <input
              type="password"
              id="oldPassword"
              name="oldPassword"
              value={passwordData.oldPassword}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">New Password:</label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              value={passwordData.newPassword}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password:</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={passwordData.confirmPassword}
              onChange={handleInputChange}
              required
            />
          </div>

          <button type="submit" className="profile-save-btn" disabled={loading}>
            {loading ? 'Changing Password...' : 'Submit'}
          </button>
        </form>
      )}
    </div>
  );
};

PasswordManagement.propTypes = {
  employeeId: PropTypes.string,
  onChangePassword: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default PasswordManagement;